import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CCardFooter,
} from "@coreui/react";

import { apiClient } from "services/Api";
import { jwtDecode } from "jwt-decode";
import ToastNotification from "components/globals/ToastNotification";
import { triggerAlert } from "components/globals/AlertNotification";

const CompetingCompany = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [permissions, setPermissions] = useState({ can_update: true });
  const location = useLocation();
  const [toast, setToast] = useState(null);

  const token = localStorage.getItem("access_token");
  const decodedToken = jwtDecode(token);

  const fetchCompetingCompanyDetails = async () => {
    try {
      const response = await apiClient.get(`/competing-companies/${id}/`);
      setFormData(response.data.company); // Update state
      setPermissions(response.data.permissions);
    } catch (error) {
      triggerAlert("Empresa não foi encontrada!", "error");
      navigate("/empresas-concorrentes");
    }
  };

  useEffect(() => {
    if (!id) {
      setFormData({});
    } else {
      fetchCompetingCompanyDetails();
    }
  }, [id, location.pathname]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      let updatedForm = {
        ...prevFormData,
        [name]: value,
      };

      return updatedForm;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await apiClient.put(`/competing-companies/${id}/`, formData);
        triggerAlert("Empresa atualizada com sucesso!", "success");
        navigate(`/empresas-concorrentes`);
      } else {
        await apiClient.post("/competing-companies/", formData);
        triggerAlert("Empresa criada com sucesso!", "success");
        navigate("/empresas-concorrentes");
      }
    } catch (error) {
      const message =
        error?.response?.status === 403
          ? "Não tem permissões para realizar esta ação."
          : "Preencha todos os campos";
      setToast({ title: "Erro ao gravar", message, type: "error" });
    }
  };

  if (formData !== null) {
    return (
      <div className="container mt-4">
        {/* Error Toast - Appears on submit failure */}
        <ToastNotification toast={toast} setToast={setToast} />

        <CCard>
          <CCardHeader>
            <h4>{id ? "Editar Empresa" : "Nova Empresa"}</h4>
          </CCardHeader>
          <CCardBody>
            <CForm onSubmit={handleSubmit}>
              <CFormInput
                type="numeric"
                label="NIF"
                name="nif"
                value={formData.nif}
                onChange={handleInputChange}
                className="mb-3"
                required
              />

              <CFormInput
                type="text"
                label={<strong>Nome da empresa</strong>}
                name="name"
                value={formData.name ?? ""}
                onChange={handleInputChange}
                className="mb-3"
                required
              />
            </CForm>
          </CCardBody>
          <CCardFooter className="d-flex justify-content-end gap-2">
            <CButton
              color="danger"
              className="text-white"
              onClick={() => navigate("/empresas-concorrentes")}
            >
              Cancelar
            </CButton>
            {(!id || permissions.can_update) && (
              <CButton
                color="success"
                className="text-white"
                type="submit"
                onClick={handleSubmit}
              >
                Confirmar
              </CButton>
            )}
          </CCardFooter>
        </CCard>
      </div>
    );
  }
};

export default CompetingCompany;
